import { FC } from 'react';

import Text from 'components/_core/Text';

import { BeneficiaryStatusBadgeProps } from '../types';
import { badgeColor, badgeStatus } from './helpers';
import { BeneficiaryCardBadge, BeneficiaryCardBadgeContainer } from './styles';

const BeneficiaryStatusBadge: FC<BeneficiaryStatusBadgeProps> = ({
  invitation,
  onboardingStatus,
}) => {
  const color = badgeColor(invitation, onboardingStatus);

  return (
    <BeneficiaryCardBadgeContainer>
      <BeneficiaryCardBadge
        color={color}
        colorVariant={color === 'turquoise' ? 4 : 3}
      >
        <Text
          color={`${color}.-2`}
          fontWeight="weight-500"
          size="sm"
          variant="primary"
        >
          {badgeStatus(invitation, onboardingStatus)}
        </Text>
      </BeneficiaryCardBadge>
    </BeneficiaryCardBadgeContainer>
  );
};
export default BeneficiaryStatusBadge;
